
export const faqTranslate = {
    es : {
        title: `Preguntas frecuentes`,
        content: [
            {
                title: `¿Qué es Viva Fan y cómo funciona?`,
                content : `Viva Fan es la membresía que te otorga descuentos en tarifas y beneficios de viaje en vuelos de Viva Aerobus.`,
                open: false,
            },
            {
                title: `¿Puedo cambiar al titular de la membresía?`,
                content : `No. Tanto la membresía Viaja Solo como la membresía Viaja Acompañado es personal, única e intransferible, por lo que nadie más puede utilizarla.`
            },
            {
                title: `¿Mis acompañantes pueden viajar solos?`,
                content : `No. El titular de la membresía deberá viajar con los acompañantes en todas las reservas. Cada uno de ellos será variable pudiendo el titular viajar con una persona diferente en cada reservación.`
            },
            {
                title: `¿Qué vigencia tiene mi membresía?`,
                content : `A partir del día de tu compra, la membresía tiene un año de duración, sin renovación automática.`
            },
            {
                title: `¿Cómo recupero mi contraseña?`,
                content : `La contraseña de tu membresía es la misma que utilizas para iniciar sesión en <a href="https://www.vivaaerobus.com"> www.vivaaerobus.com</a>. Si la olvidaste, sólo debes hacer clic en “olvidé mi contraseña”.`
            },
            {
                title: `¿Qué pasa si al iniciar sesión se me indica que no tengo membresía?`,
                content : `Si cuentas con una membresía Viva Fan y no puedes utilizarla, o tienes algún problema para iniciar sesión, puedes escribirnos a <a href="mailto:vivafan@vivaaerobus.com">vivafan@vivaaerobus.com</a> y con gusto te ayudaremos a resolverlo.`
            },
            {
                title: `¿Cómo obtengo mi factura?`,
                content : `Puedes solicitar tu factura desde tu perfil Viva Fan, solo deberás añadir los datos de tu constancia fiscal y hacer click en “solicitar factura”`
            },
            {
                title: `¿Cómo añado a mi reserva el beneficio de kilos adicionales?`,
                content : `La membresía Viva Fan te da acceso a 5 kilos adicionales en equipaje de mano al reservar en Combo Extra o 7 kilos adicionales de equipaje documentado al reservar en Combo Smart. Al reservar tu vuelo podrás seleccionar el beneficio de equipaje Viva Fan y este se añadirá a tu reserva.`
            },
            {
                title: `¿A qué beneficios tendrán acceso mis acompañantes?`,
                content : `Los acompañantes deberán viajar con el titular de la membresía y accederán únicamente al beneficio de descuento en tarifas. Los acompañantes no podrán acceder al beneficio de equipaje adicional o al uso de Smile & Fly.`
            },
        ],
    },
    eng : {
        title: `Frequently Asked Questions`,
        content: [
            {
                title: `What is Viva Fan, and how does it work?`,
                content : `Viva Fan is the membership that gives you discounts on fares and travel benefits when flying Viva Aerobus.`
            },
            {
                title: `Can I change the name of the membership holder?`,
                content : `No. Both the Travel Solo and Travel Accompanied memberships are personal and non-transferable, so nobody else can use them.`
            },
            {
                title: `Can my companions travel without me?`,
                content : `No. The membership holder must travel with companions on all reservations. Each one of them will be variable and the holder can travel with a different person in each reservation.`
            },
            {
                title: `How long is my membership valid for?`,
                content : `Your membership is valid for a year from the date of purchase without automatic renovation.`
            },
            {
                title: `How can I recover my password?`,
                content : `Your membership password is the same one you use to log into <a href="https://www.vivaaerobus.com" target="_blank"> www.vivaaerobus.com </a>. If you forgot it, click on “Forgot my password?”.`
            },
            {
                title: `What if I log in and get a message saying I don't have a membership?`,
                content : `If you have a Viva Fan membership and cannot use it or have a problem logging in, send an email to: <a href="mailto:vivafan@vivaaerobus.com">vivafan@vivaaerobus.com</a>, and we will be happy to help you.`
            },
            {
                title: `How can I get an invoice?`,
                content : `You can request an invoice from your Viva Fan profile. Add your tax information and click on “request invoice”.`
            },
            {
                title: `How can I add the benefit of additional weight to my reservation?`,
                content : `Your Viva Fan membership gives you access to an additional 10 lb in carry-on baggage when you book Extra Fare, or an additional 14 lb in checked baggage when you book Smart Fare. Select the Viva Fan benefit when you book your flight, and it will be added to your reservation.`
            },
            {
                title: `What are the benefits for my companions? `,
                content : `Companions must travel with the membership holder and can only access discounted fares. Companions cannot access the additional baggage benefit or use Smile & Fly. `
            },
        ],
       
    }
}